<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Supervisor (Pengawas)</h4>
              <button class="float-right btn btn-primary shadow" v-on:click="formSupervisorActive=!formSupervisorActive">Supervisor Baru</button>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formSupervisorActive">
                <div class="row p-3 mx-2 bg-white shadow">
                    <div class="col-12 mb-3">
                        <h4 class="my-0 py-0">Form Supervisor</h4>
                        <hr>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Nama</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newSupervisor.name" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Telephone</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newSupervisor.telephone" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Email</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newSupervisor.email" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2">
                        <label class="d-block">Alamat</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newSupervisor.address" />
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newSupervisorSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil Menyimpan Data Supervisor Baru.
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewSupervisor">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal Menyimpan Data Supervisor Baru.</p>
                                </div>
                                <div v-for="err in errorSupervisorList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewSupervisor">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewSupervisor">Submit</button>
                    </div>
                </div>
            </div>
            </transition>

        
          <div class="col-12  my-2 py-0">
            <datatable :datas="supervisors" :structure="supervisorTableStructure" :init="loadData">
                <template #head>
                    <th>Tindakan</th>
                </template>
                <template #addon="{item}">
                    <td>
                        <b-button v-b-modal.modal-edit-user class="btn btn-info mr-2"><b-icon icon="pencil-square"></b-icon></b-button>
                        <button v-on:click="deleteItem(item)" class="btn btn-danger"><b-icon icon="trash"></b-icon></button>
                    </td>
                </template>
            </datatable>
          </div>
        <b-modal id="modal-edit-user" title="Edit data" no-close-on-backdrop size="lg">
        <div class="row" v-if="supervisors[selectedIdforEdit]!=undefined">
          <div class="col-12 col-md-6 col-lg-4 mt-2">
            <label class="d-block">Nama</label>
            <input type="text"  class="form-control w-100 rounded" v-model="supervisors[selectedIdforEdit].name" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mt-2">
            <label class="d-block">Telephone</label>
            <input type="text"  class="form-control w-100 rounded" v-model="supervisors[selectedIdforEdit].telephone" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mt-2">
            <label class="d-block">Email</label>
            <input type="text"  class="form-control w-100 rounded" v-model="supervisors[selectedIdforEdit].email" />
          </div>
          <div class="col-12 col-md-6 col-lg-4 mt-2">
            <label class="d-block">Alamat</label>
            <input type="text"  class="form-control w-100 rounded" v-model="supervisors[selectedIdforEdit].address" />
          </div>
          <div class="col-12 mt-3">
            <div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
              <div class="alert alert-success" role="alert">
                  Berhasil Update Data Supervisor Baru.
              </div>
            </div>
          </div>
        </div>
          <template #modal-footer>
              <div class="w-100 text-right m-0 p-0">
              <hr> 
              <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal Menyimpan Data Supervisor Baru.</p>
                                </div>
                                <div v-for="err in errorSupervisorList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="updating">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-user')">close</b-button>
                        <button class="btn btn-info float-right" type="button" v-on:click="saveNewSupervisor">Submit</button>
                    </div>
              </div>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect
        },
        data () {
            return {
                 isMobile:false,

                supervisors:[],
                searchValue:'',
                loadData:true,
                updateSaved:false,
                updating:false,
                savingNewSupervisor:false,
                errorNewSupervisor:false,
                errorUpdate:false,
                errorSupervisorList:[],
                existingClientResult:[],
                newSupervisorSaved:false,
                selectedTab:0,
                selectedIdforEdit:0,
                newSupervisor:{
                    name:'',
                    telephone:'',
                    email:'',
                    address:'',
                },
                formSupervisorActive:false,
                supervisorTableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'Nama',key:'name'},
                    {label:'Telephone',key:'telephone'},
                    {label:'Email',key:'email'},
                    {label:'Alamat',key:'address'},
                ],
            }
        },
        created(){
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            this.getSupervisors();
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            getSupervisors(url=(this.$baseUrl+'/api/master/supervisor')){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.supervisors = result.data.data;
                    this.loadData=false
                }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                    console.log(err)
                    this.loadData=false
                })
            },
            updateSupervisor(){
                this.updating=true
                this.errorUpdate=false
                axios.put(this.$baseUrl+'/api/master/supervisor/'+this.supervisors[this.selectedIdforEdit].id,this.supervisors[this.selectedIdforEdit],{
                    headers:{'Authorization':'Bearer '+ localStorage.getItem('accessToken')}
                }).then((result)=>{
                    if(result.status=200){
                        this.updating=false
                        this.updateSaved=true
                        setTimeout(() => {
                            this.updateSaved=true
                        }, 1500);
                    }
                    console.log(result)
                }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                    this.updating=false
                    this.errorUpdate=true
                    console.log(err.response)
                })
            },
            saveNewSupervisor(){
                this.savingNewSupervisor=true
                this.errorNewSupervisor=false
                console.log(this.newSupervisor)
                if(this.newSupervisor.name!='' && this.newSupervisor.telephone!='' && this.newSupervisor.email && this.newSupervisor.address){
                    axios.post(this.$baseUrl+'/api/master/supervisor',
                    {
                        name:this.newSupervisor.name,
                        telephone:this.newSupervisor.telephone,
                        email:this.newSupervisor.email,
                        address:this.newSupervisor.address
                    },
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        //console.log(result)
                        if(result.data.create){
                            this.getSupervisors();
                        }
                        this.newSupervisor.name='',
                        this.newSupervisor.telephone='',
                        this.newSupervisor.email='',
                        this.newSupervisor.address='',
                        this.savingNewSupervisor=false
                        this.newSupervisorSaved=true

                        setTimeout(() => {
                            this.newSupervisorSaved=false
                            this.formSupervisorActive=false
                        }, 1500);

                    }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
                        console.log(err.response)
                        this.errorSupervisorList=[]
                        this.errorSupervisorList=Object.values(err.response.data.errors)
                        console.log(this.errorSupervisorList)
                        this.errorNewSupervisor=true
                        this.savingNewSupervisor=false
                    })
                }
            },
            newUsernameChange(){
                this.newSupervisor.password = this.newSupervisor.username.toUpperCase();
            },
            deleteItem(item){
                console.log('button delete untuk user id: '+item.id)
            },
            updateUserRoleValue(newValue){
                this.newSupervisor.role=newValue
            },
            setNewClientId(newId){
                this.newSupervisor.clientId = newId;
                console.log(this.newSupervisor.clientId)
            }
            
        },
    }
</script>
<style scoped>
.btn {
    padding:2px 6px;
}
</style>